import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { format, addDays, startOfWeek, addWeeks } from 'date-fns';

interface Schedule {
  time: string;
  teacher: string;
  grade: string;
}

@Component({
  selector: 'app-calender-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './calender-card.component.html',
  styleUrl: './calender-card.component.scss'
})
export class CalenderCardComponent {

  currentWeekStart!: Date;
  weekDays: { date: Date; label: string; shortDay: string }[] = [];
  formattedCurrentMonthYear!: string;
  selectedDate!: Date;
  schedules: Schedule[] = [];

  mockSchedules: { [key: string]: Schedule[] } = {
    '2025-03-18': [
      { time: '11:00', teacher: 'Teacher Name', grade: '6ᵗʰ (A)' },
      { time: '12:00', teacher: 'Teacher Name', grade: '9ᵗʰ (A)' }
    ],
    '2025-03-20': [
      { time: '10:00', teacher: 'Teacher 2', grade: '7ᵗʰ (B)' },
      { time: '11:30', teacher: 'Teacher 3', grade: '8ᵗʰ (A)' }
    ]
  };

  ngOnInit() {
    const today = new Date();
    this.currentWeekStart = startOfWeek(today, { weekStartsOn: 1 });
    this.formattedCurrentMonthYear = format(this.currentWeekStart, 'MMMM yyyy');
    this.selectedDate = new Date;

    this.updateWeekDays();
    this.selectDay(today); // ✅ Load today's schedule by default
  }

  updateWeekDays() {
    this.formattedCurrentMonthYear = format(this.currentWeekStart, 'MMMM yyyy');
    this.weekDays = Array.from({ length: 6 }).map((_, i) => {
      const date = addDays(this.currentWeekStart, i);
      return { 
        date, 
        label: format(date, 'dd'),
        shortDay: format(date, 'EEE') 
      };
    });
  }

  selectDay(date: Date) {
    this.selectedDate = date;
    const dateString = format(date, 'yyyy-MM-dd');
    this.schedules = this.mockSchedules[dateString] || [];
  }

  changeWeek(offset: number) {
    this.currentWeekStart = addWeeks(this.currentWeekStart, offset);
    this.updateWeekDays();
  }


}
